module.exports = __webpack_public_path__ + "media/images/online/online-wedding-icon-photo-51317d94ea98b801267374428764a2d1.png";